import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import { MbButtonComponent } from '../mb-button/mb-button.component';

import {
  SupportingDocument,
  Timeline,
} from '../../../core/services/cases.service';

@Component({
  selector: 'app-mb-timeline-item',
  standalone: true,
  imports: [
    CommonModule,
    NzTimelineModule,
    NzIconModule,
    MbButtonComponent,
    NzModalModule,
    FormsModule,
    TranslocoDirective,
  ],
  templateUrl: './mb-timeline-item.component.html',
  styleUrls: ['./mb-timeline-item.component.css'],
})
export class MbTimelineItemComponent {
  @Input() followUp!: Timeline;
  @Input() organizationId?: string | null;
  @Output() downloadDocument = new EventEmitter<{
    type: string;
    url: string;
  }>();
  isStatusModalVisible = false;
  statusModalTitle = '';
  statusComment = '';
  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;
  handleStatusModalCancel(): void {
    this.isStatusModalVisible = false;
  }

  showStatusModal(): void {
    this.isStatusModalVisible = true;
  }

  isImageDocument(document: SupportingDocument): boolean {
    const imageExtensions = [
      '.png',
      '.jpg',
      '.jpeg',
      '.gif',
      '.webp',
      '.bmp',
      '.svg',
    ];
    return document?.filename
      ? imageExtensions.some((ext) =>
          document.filename.toLowerCase().includes(ext),
        )
      : false;
  }

  onDownloadDocument(document: { filename: string; url: string }): void {
    this.downloadDocument.emit({ type: 'document', url: document.url });
  }

  showRejectInvitationModal(): void {
    this.isStatusModalVisible = true;
    this.statusModalTitle = 'Reject Invitation';
    this.statusComment = '';
  }
}
